import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import { Label } from "@/app/components/Label/Label.jsx";
import SearchableSelectInput from "@/app/components/SearchableSelectInput/SearchableSelectInput.jsx";
import { useCreateApplication, useJobs } from "@/app/services/create-resume/queries.js";

import { Modal } from "../../../Profile/components/Modal.jsx";

const ApplicationRegModal = ({ isOpen, onClose }) => {
	const [searchedJob, setSearchedJob] = useState(null);
	const [jobs, setJobs] = useState([]);
	const [searchParams, setSearchParams] = useState({
		city: "",
		title: "",
		region: "",
		pageNumber: 1,
		jobExpertise: [],
		country: "Tanzania",
	});
	const { data, isLoading, error } = useJobs({ params: searchParams });
	const createApplicationMutation = useCreateApplication({
		onSuccess: () => {
			toast.success("Application registered successfully.");
			onClose();
		},
	});

	const handleSubmit = async () => {
		try {
			await createApplicationMutation.mutateAsync({
				payload: jobs.find((job) => job.jobId === searchedJob),
			});
		} catch (error) {
			toast.error(error.message);
		}
	};

	const onJobSearch = async (term) => {
		const searchQueryParams = {
			title: term,
			pageNumber: 1,
			country: "Tanzania",
		};

		setSearchParams(searchQueryParams);
	};

	useEffect(() => {
		if (!isLoading && data) {
			successCallBack(data);
		}

		if (!isLoading && error) {
			toast.error("Something went wrong");
		}
	}, [data, isLoading, error]);

	const successCallBack = (response) => {
		const formatedJobs = response?.data?.[0]?.paginatedJobs?.flatMap((item) =>
			item.jobs.map((job) => ({
				jobId: job._id,
				jobTitle: job.jobTitle,
				companyId: item.company,
				companyLogo: item.companyDetails.logo_url,
				companyName: item.companyDetails.company_name,
			})),
		);

		setJobs(formatedJobs);
	};

	return (
		<Modal
			isOpen={isOpen}
			size="medium"
			onClose={onClose}
			title="Register Application"
			subTitle="Register and track the progress of your application"
			secondaryAction={{
				label: "Cancel",
				onClick: () => onClose(),
			}}
			primaryAction={{
				label: "Register",
				onClick: () => handleSubmit(),
			}}
		>
			<div className="overflow-y-auto">
				<div className="">
					<div className="pb-3 min-h-[calc(100vh-30rem)] overflow-y-auto pr-2">
						<div className="space-y-3 mb-3">
							<div className="p-3 space-y-4">
								<div>
									<Label htmlFor="document-type" className="text-sm font-medium text-gray-700 mb-1.5 block">
										Select the job you have applied.
									</Label>
									<SearchableSelectInput
										value={searchedJob}
										fetchOptions={onJobSearch}
										defaultLabel="Search or choose job"
										onSelect={(val) => setSearchedJob(val)}
										options={jobs.map((job) => ({
											value: job.jobId,
											label: job.jobTitle,
											subLabel: job.companyName,
										}))}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default ApplicationRegModal;
